export default {
  sendUrl: '/api/v1/videos/rotator/'
}
